import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Calculator = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="calculator icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_4_2821)">
      <path
        className={pathClass}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 2C3 0.89543 3.89543 0 5 0H19C20.1046 0 21 0.895431 21 2V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V2ZM6 3H18V7H6V3ZM9 9H6V12H9V9ZM6 13.5H9V16.5H6V13.5ZM9 18H6V21H9V18ZM10.5 9H13.5V12H10.5V9ZM13.5 13.5H10.5V16.5H13.5V13.5ZM10.5 18H13.5V21H10.5V18ZM18 9H15V12H18V9ZM15 13.5H18V16.5H15V13.5ZM18 18H15V21H18V18Z"
      />
    </g>
  </svg>
)
